import { render, staticRenderFns } from "./AuditLog.vue?vue&type=template&id=672495d8&scoped=true"
import script from "./AuditLog.vue?vue&type=script&lang=js"
export * from "./AuditLog.vue?vue&type=script&lang=js"
import style0 from "./AuditLog.vue?vue&type=style&index=0&id=672495d8&prod&scoped=true&lang=scss"
import style1 from "./AuditLog.vue?vue&type=style&index=1&id=672495d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672495d8",
  null
  
)

export default component.exports